{
  "_comment": "[CI-LOCKED] O conteúdo deste arquivo está bloqueado. Contribuições são bem-vindas, mas pode haver atrasos na validação das alterações.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "O bot $1 disse:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agente",
  "ACTIVITY_YOU_SAID_ALT": "Você disse:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Bot anexado:",
  "ACTIVITY_CODE_ALT": "Exemplo de código: $1",
  "ACTIVITY_CONTENT_CAUTION": "O conteúdo gerado por IA pode estar incorreto",
  "ACTIVITY_CODE_CAUTION": "Código gerado por IA. Revise e use com cuidado",
  "ACTIVITY_ERROR_BOX_TITLE": "Mensagem de erro",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Clique para interagir.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "A mensagem é interativa.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Um ou mais links na mensagem.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Falha no envio.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Você anexou:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 anexo.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 anexos.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Falha no envio. [Repetir][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Enviando",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Enviado às $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Agora",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Há uma hora",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Há um minuto",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Hoje",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Ontem",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Erro de análise do Cartão Adaptável",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Erro de renderização do Cartão Adaptável",
  "ATTACHMENT_AUDIO": "Um clipe de áudio.",
  "ATTACHMENT_CARD": "Um cartão: $1 $2 $3",
  "ATTACHMENT_FILE": "Um arquivo: $1",
  "ATTACHMENT_IMAGE": "Uma imagem",
  "ATTACHMENT_TEXT": "Um texto: $1",
  "ATTACHMENT_VIDEO": "Um videoclipe",
  "AVATAR_ALT": "Avatar de $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Avançar",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Voltar",
  "CITATION_MODEL_DIALOG_ALT": "Citação",
  "CLOSE_BUTTON_ALT": "Fechar",
  "COLLAPSIBLE_GROUPING_TITLE": "Pensativo...",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Isso será mostrado quando o bot está compondo mensagens de resposta em um grupo, se nenhum resumo for fornecido.",
  "COLLAPSE_BUTTON_LESS": "Mostrar menos",
  "COLLAPSE_BUTTON_LESS.comment": "Esse é o texto de um botão com chevron para recolher o grupo de mensagens. Quando o usuário final clica no botão, o grupo de mensagens se recolhe.",
  "COLLAPSE_BUTTON_MORE": "Mostrar mais",
  "COLLAPSE_BUTTON_MORE.comment": "Esse é o texto de um botão com chevron para expandir o grupo de mensagens. Quando o usuário clica no botão, o grupo de mensagens se expande.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Conectado",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Conectando…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Não é possível conectar.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Ocorreu uma interrupção da rede. Reconectando…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Erro de renderização. Verifique o console ou contate o desenvolvedor de bot.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "A conexão está demorando mais do que o habitual.",
  "CONNECTIVITY_STATUS_ALT": "Status da Conectividade: $1",
  "COPY_BUTTON_TEXT": "Copiar",
  "COPY_BUTTON_COPIED_TEXT": "Copiado(a)",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Enviar",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Cancelar",
  "FEEDBACK_FORM_PLACEHOLDER": "Forneça o máximo de detalhes possível, mas não inclua informações privadas ou confidenciais.",
  "FEEDBACK_FORM_TITLE": "Conte-nos sobre a sua experiência",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Baixar o arquivo '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Baixar o arquivo '$1' de tamanho $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "'$1' de tamanho $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Abre em uma nova janela externa.",
  "RECEIPT_CARD_TAX": "Imposto",
  "RECEIPT_CARD_TOTAL": "Total",
  "RECEIPT_CARD_VAT": "IVA",
  "REFERENCE_LIST_HEADER_ONE": "$1 referência",
  "REFERENCE_LIST_HEADER_FEW": "$1 referências",
  "REFERENCE_LIST_HEADER_MANY": "$1 referências",
  "REFERENCE_LIST_HEADER_OTHER": "$1 referências",
  "REFERENCE_LIST_HEADER_TWO": "$1 referências",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Excluir anexo $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Excluir",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Um arquivo",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Uma imagem",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Não é possível enviar uma mensagem vazia.",
  "SPEECH_INPUT_LISTENING": "Escutando…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Microfone desligado",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Microfone ligado",
  "SPEECH_INPUT_STARTING": "Iniciando…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Avançar",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Voltar",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Ações sugeridas",
  "TEXT_INPUT_ALT": "Caixa de entrada de mensagens",
  "TEXT_INPUT_PLACEHOLDER": "Digite sua mensagem",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Comece a falar…",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Ouvindo...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Processando...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Fale para interromper…",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Enviar",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Falar",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Carregar arquivo",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Teclado telefônico",
  "TEXT_INPUT_DROP_ZONE": "Soltar arquivos",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Tamanho de mensagem excedido",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Só tem suporte para entrada de um dígito",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 anexo",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 anexos",
  "TOAST_ACCORDION_FEW": "$1 Notificações: clique aqui para ver os detalhes",
  "TOAST_ACCORDION_MANY": "$1 Notificações: clique aqui para ver os detalhes",
  "TOAST_ACCORDION_OTHER": "$1 Notificações: clique aqui para ver os detalhes",
  "TOAST_ACCORDION_TWO": "$1 Notificações: clique aqui para ver os detalhes",
  "TOAST_ALT_ERROR": "Erro",
  "TOAST_ALT_INFO": "Informação",
  "TOAST_ALT_SUCCESS": "Sucesso",
  "TOAST_ALT_WARN": "Aviso",
  "TOAST_DISMISS_BUTTON": "Ignorar",
  "TOAST_TITLE_ALT": "Notificação",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Histórico de chat, use as teclas de seta para navegar.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "histórico de chat",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "A mensagem é interativa. Pressione a tecla Shift Tab de 2 para 3 vezes para alternar para o histórico do chat. Depois, clique na mensagem para interagir.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Um ou mais links na mensagem. A mensagem é interativa. Pressione a tecla Shift Tab de 2 para 3 vezes para alternar para o histórico do chat. Depois, clique na mensagem para interagir.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "A mensagem tem ações sugeridas. Pressione shift tab de 2 a 3 vezes para selecioná-las.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "A mensagem tem ações sugeridas. Pressione $1 para selecioná-las.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Falha ao enviar a mensagem.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Novas mensagens disponíveis. Pressione $1 para focalizar o botão \"$2\".",
  "TRANSCRIPT_MORE_MESSAGES": "Mais mensagens",
  "TRANSCRIPT_NEW_MESSAGES": "Novas mensagens",
  "TRANSCRIPT_TERMINATOR_TEXT": "Término do histórico de chat",
  "TYPING_INDICATOR_ALT": "Mostrando o indicador de digitação",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 está digitando.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 e outros estão digitando.",
  "VIEW_CODE_BUTTON_TEXT": "Código",
  "VOTE_COMPLETE_ALT": "Comentários gravados",
  "VOTE_COMPLETE_ALT.comment": "Isso se destina ao leitor de tela. O rótulo de um botão com ícones de polegar para cima/baixo. O rótulo será usado quando os comentários tiverem sido gravados.",
  "VOTE_DISLIKE_ALT": "Não gostei",
  "VOTE_LIKE_ALT": "Gostei"
}